import React from 'react';
import PendingServiceDetailsSideBar from "./PendingServiceDetailsSideBar";
import ProgressTrackerBar from "./ProgressTrackerBar";
import ProgressTrackerRowsMobile from "./ProgressTrackerRowsMobile";

const PendingConnectionMobile = ({serviceDetails, status}) => {
    return (
        <div className='pending-connection-mobile'>
            <div className='d-flex flex-column flex-sm-row'>
                <div className='left mr-4'>
                    <PendingServiceDetailsSideBar serviceDetails={serviceDetails}/>
                </div>
                <div className='right'>
                    <h3 className="m-0 mb-3 bold">Progress tracker</h3>
                    <ProgressTrackerBar data={status}/>
                    <div className="mt-5">
                        <ProgressTrackerRowsMobile
                            data={status}
                            serviceDetails={serviceDetails}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PendingConnectionMobile



// WEBPACK FOOTER //
// ./resources/js/modules/PendingConnection/PendingConnectionMobile.js